import { render, staticRenderFns } from "./DayAbsence.vue?vue&type=template&id=089950b0"
import script from "./DayAbsence.vue?vue&type=script&lang=js"
export * from "./DayAbsence.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports